import React from 'react'
import "./Offers.css"
import exclusive_image from "../Assest/Frontend_Assets/exclusive_image.png"
import { Link } from "react-router-dom";


function Offers() {
  return (
    <div className='offers'>
        <div className='offers-left'>
          <h1>Exclusive</h1>
            <h1>offers for you</h1>
            <p>ONLY ON BEST SELLERS PRODUCTS</p>
            <Link className='link' to="/womens" >Check Now</Link>
        </div>
        <div className='offers-right'>
            <img src={exclusive_image} alt='exclusive_image'/>
        </div>
    </div>
  )
}


export default Offers